import { render, staticRenderFns } from "./MobileType.vue?vue&type=template&id=5c74cb50&scoped=true&"
import script from "./MobileType.vue?vue&type=script&lang=js&"
export * from "./MobileType.vue?vue&type=script&lang=js&"
import style0 from "./MobileType.vue?vue&type=style&index=0&id=5c74cb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74cb50",
  null
  
)

export default component.exports